const MONTHS_SHORT = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];

const eur = digits => new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR', minimumFractionDigits: digits, maximumFractionDigits: digits});
const EUR_0 = eur(0);
const EUR_2 = eur(2);
const EUR_COMPACT = new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR', notation: 'compact', maximumFractionDigits: 1});
const NUMBER = new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 1});

/** Les petits montants gardent leurs centimes, les grands sont arrondis à l'euro */
export const money = value => (Math.abs(value ?? 0) >= 1000 ? EUR_0 : EUR_2).format(value ?? 0);
export const moneyCompact = value => EUR_COMPACT.format(value ?? 0);
export const integer = value => NUMBER.format(value ?? 0);
export const percent = value => `${NUMBER.format(value ?? 0)} %`;
export const days = value => `${NUMBER.format(value ?? 0)} j`;

const FORMATTERS = {money, integer, percent, days};

/** Valeur formatée selon son genre (money, integer, percent, days) */
export const formatValue = (kind, value) => (FORMATTERS[kind] ?? integer)(value);

/** Libellé court d'une période : 2026-03 → « mars 26 », 2026-T1 → « T1 2026 », 2026 → « 2026 » */
export function bucketLabel(key) {
    const month = /^(\d{4})-(\d{2})$/.exec(key);
    if (month) return `${MONTHS_SHORT[Number(month[2]) - 1]} ${month[1].slice(2)}`;
    const quarter = /^(\d{4})-T(\d)$/.exec(key);
    if (quarter) return `T${quarter[2]} ${quarter[1]}`;
    return String(key);
}

export const monthLabel = month => MONTHS_SHORT[month - 1];

/** AAAA-MM-JJ → JJ/MM/AAAA */
export const displayDay = day => (day ? day.split('-').reverse().join('/') : '');

/** Somme cumulée d'une série de valeurs */
export function cumulative(values) {
    let total = 0;
    return values.map(value => Math.round((total += value) * 100) / 100);
}

/** Au moins une valeur non nulle : sinon le graphique n'a rien à montrer */
export const hasData = values => values.some(value => !!value);
